//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { CategoriesConfigurations } from './models/CategoriesConfigurations';
import type { CategoryConfiguration } from './models/CategoryConfiguration';
import type { KeywordConfiguration } from './models/KeywordConfiguration';
import type { ProductSubscriptionConfig } from './models/ProductSubscriptionConfig';
import { Utilities } from './Utilities';

export class ConfigurationsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getProductSubscriptionConfiguration: (
			productId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/configurations/products/{productId}';
            if (productId === undefined || productId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('productId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{productId}', encodeURIComponent(String(productId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getKeywordConfiguration: (
			keywordId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/configurations/keywords/{keywordId}';
            if (keywordId === undefined || keywordId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('keywordId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{keywordId}', encodeURIComponent(String(keywordId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getCategoryConfiguration: (
			categoryId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/configurations/categories/{categoryId}';
            if (categoryId === undefined || categoryId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('categoryId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{categoryId}', encodeURIComponent(String(categoryId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAllCategoryConfiguration: (
			onlyVisibleForSubscriptions?: boolean,
        ): string => {
            let clientRequestUrl = '/api/v1/configurations/categories?';
            if (onlyVisibleForSubscriptions === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('onlyVisibleForSubscriptions'));
            } else if (onlyVisibleForSubscriptions !== undefined) {
                clientRequestUrl += `onlyVisibleForSubscriptions=${encodeURIComponent(String(onlyVisibleForSubscriptions))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get product's subscription configuration
     * @param productId ProductId
     * @return OK
     */
    async getProductSubscriptionConfiguration(
        productId: number,
    ): Promise<ProductSubscriptionConfig> {
        const clientRequestUrl = this.baseUrl + this.routes.getProductSubscriptionConfiguration(
            productId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ProductSubscriptionConfig>(_response, false, []);
    }

    /**
     * Get keyword's configuration
     * @param keywordId KeywordId
     * @return OK
     */
    async getKeywordConfiguration(
        keywordId: number,
    ): Promise<KeywordConfiguration> {
        const clientRequestUrl = this.baseUrl + this.routes.getKeywordConfiguration(
            keywordId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<KeywordConfiguration>(_response, false, []);
    }

    /**
     * Get research category's configuration
     * @param categoryId categoryId
     * @return OK
     */
    async getCategoryConfiguration(
        categoryId: number,
    ): Promise<CategoryConfiguration> {
        const clientRequestUrl = this.baseUrl + this.routes.getCategoryConfiguration(
            categoryId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<CategoryConfiguration>(_response, false, []);
    }

    /**
     * Get all research category's configuration
     * @param onlyVisibleForSubscriptions (optional) onlyVisibleForSubscriptions
     * @return OK
     */
    async getAllCategoryConfiguration(
        onlyVisibleForSubscriptions?: boolean,
    ): Promise<CategoriesConfigurations> {
        const clientRequestUrl = this.baseUrl + this.routes.getAllCategoryConfiguration(
            onlyVisibleForSubscriptions,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<CategoriesConfigurations>(_response, false, []);
    }
}
